<template>
  <div class="box">
    <!--<div>-->
    <!--<el-form  :inline="true" class="demo-form-inline" size="mini">-->
        <!--<el-form-item label="栏目:">-->
          <!--&lt;!&ndash;<el-select v-model="params.categoryId" clearable style="width: 90px;margin-right: 5px"  placeholder="栏目">&ndash;&gt;-->
            <!--&lt;!&ndash;<el-option label="全部" value="">&ndash;&gt;-->
            <!--&lt;!&ndash;</el-option>&ndash;&gt;-->
          <!--&lt;!&ndash;</el-select>&ndash;&gt;-->
        <!--</el-form-item>-->
        <!--<el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>-->
      <!--</el-form>-->
    <!--</div>-->
    <div>
      <el-table
        v-loading="loading"
        :data="appUsers.userPermission"
        stripe
        :height="windowHeight"
        style="width: 100%;z-index: 1;font-size: 12px">
        <el-table-column
          label="加入日期"
          label-class-name="header">
          <template slot-scope="scope">
            <span>{{new Date(scope.row.joinDate).format("yyyy-MM-dd")}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="姓名"
          label-class-name="header">
          <template slot-scope="scope">
            {{appUsers.owner == scope.row.userId.toString()?(scope.row.name+ ' (所有者)'):scope.row.name}}
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="电话"
          label-class-name="header">
        </el-table-column>
        <!--<el-table-column-->
          <!--label="备注/删除"-->
          <!--label-class-name="header">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button v-if="appUsers.owner != scope.row.userId.toString()"-->
              <!--size="mini"-->
              <!--type="primary"-->
            <!--&gt;删除</el-button>-->
          <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column
          label="操作"
          label-class-name="header">
          <template slot-scope="scope">
            <el-button v-if="appUsers.owner != scope.row.userId.toString()"
              size="mini"
              type="success"
            @click="showPermission(scope.row)">分配权限</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.current"
        node-key="id"
        :page-sizes="[15, 30, 50, 100]"
        :page-size="params.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="appUsers.userPermission.length">
      </el-pagination>
    </div>
    <el-dialog title="分配权限" :visible.sync="permissionVisible" >
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="9">
          <div style="display: flex;flex-direction: column">
            <el-divider content-position="left">菜单列表</el-divider>
            <el-tree
              ref="menuTree"
              :check-strictly="true"
              :default-expand-all="true"
              :data="data"
              node-key="menuId"
              :props="defaultProps"
              highlight-current
              show-checkbox
              :expand-on-click-node="false">
               <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                   <el-link  @click="() => getPermissionByParentId(data)" >查看权限<i class="el-icon-view el-icon--right"></i></el-link>
                </span>
              </span>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="9">
          <div style="display: flex;flex-direction: column">
            <el-divider content-position="left">权限列表</el-divider>
            <div v-show="display">
              <el-tree
                ref="permissionTree"
                :filter-node-method="filterNode"
                :default-expand-all="true"
                :data="permission"
                node-key="permissionId"
                :props="permissionProps"
                show-checkbox>
              </el-tree>
            </div>
            <div v-show="!display" style="writing-mode: vertical-lr;margin: auto;display: flex;color: #909399;letter-spacing: 8px;">
              点击左侧查看权限
            </div>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="permissionVisible=false">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="getCheckedKeys">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAppUsers, updateUserPermission } from '../../../api/app'
import { getList, getMenuList } from '../../../api/permission'
import {Message} from 'element-ui'

export default {
  data () {
    return {
      display: false,
      permissionVisible: false,
      parentId: '',
      appId: '',
      loading: true,
      windowHeight: '',
      params: {
        size: 15,
        current: 1
      },
      appUsers: {
        userPermission: []
      },
      data: [],
      permission: [],
      userPermission: {},
      defaultProps: {
        id: 'menuId',
        children: 'subs',
        label: 'menuName'
      },
      permissionProps: {
        id: 'permissionId',
        children: 'permissionId',
        label: 'name'
      }
    }
  },
  watch: {
    parentId (val) {
      this.$refs.permissionTree.filter(val)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.appId = to.params.id
      vm.getAppMenu(to.params.id)
      vm.getAppUsers(to.params.id, 15, 1)
    })
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 308
  },
  methods: {
    getAppMenu (appId) {
      let _this = this
      getMenuList().then(res => {
        _this.data = res.data.data
      })
      getList().then(res => {
        _this.permission = res.data.data
      })
    },
    getPermissionByParentId (pId) {
      this.display = true
      this.parentId = pId.menuId
    },
    showPermission (data) {
      this.permissionVisible = true
      this.userPermission.userId = data.userId
      this.$nextTick(() => {
        this.$refs.menuTree.setCheckedKeys(data.menus || [])
        this.$refs.permissionTree.setCheckedKeys(data.permission || [])
      })
    },
    getAppUsers (appId, pageSize, pageCurrent) {
      let _this = this
      _this.loading = true
      setTimeout(() => {
        getAppUsers(appId, pageSize, pageCurrent).then((response) => {
          _this.appUsers = response.data.data
          _this.loading = false
        })
      }, 500)
    },
    filterNode (value, data) {
      return data.menuId === value
    },
    getCheckedKeys () {
      let _this = this
      this.userPermission.menus = this.$refs.menuTree.getCheckedKeys()
      this.userPermission.permission = this.$refs.permissionTree.getCheckedKeys()
      updateUserPermission(this.appId, this.userPermission).then(res => {
        Message({
          message: res.data.data,
          type: 'success',
          duration: 5 * 1000
        })
        _this.getAppUsers(this.appId, this.params.size, this.params.current)
        _this.permissionVisible = false
      }).catch(() => {
        _this.permissionVisible = false
      })
    },
    handleSizeChange (val) {
      this.params.size = val
      this.getAppUsers(this.appId, this.params.size, this.params.current)
    },
    handleCurrentChange (val) {
      this.params.current = val
      this.getAppUsers(this.appId, this.params.size, this.params.current)
    },
    search () {
      this.params.current = 1
      this.getAppUsers(this.appId, this.params.size, this.params.current)
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.box
  padding 18px
  background #fff
  border-radius 5px
  font-size 12px
  transition .3s
  box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232,237,250,0.5)
  .filter-item
    display: inline-block
    vertical-align: middle
    margin-bottom: 10px
    margin-right 5px
  .header
    font-size 12px !important
.custom-tree-node
  flex: 1
  display: flex
  align-items: center
  justify-content: space-between
  font-size: 14px
  padding-right: 8px
</style>
